export default "__VITE_ASSET__c731ad2b__"